import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class ClusteredSchedulingSettings extends DataModel {
  static readonly TYPE_ID: string = '17e2848768c34820ae52002f213e5b1d';

  constructor(
    public readonly allowSchedulingFromTheFront: boolean = true,
    public readonly allowSchedulingFromTheBack: boolean = true,
    public readonly slotCount: number = 3,
  ) {
    super();
  }

  get $typeId(): string {
    return ClusteredSchedulingSettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ClusteredSchedulingSettings {
    return new ClusteredSchedulingSettings(
        MapUtils.get<boolean>(map, 'allowSchedulingFromTheFront'),
        MapUtils.get<boolean>(map, 'allowSchedulingFromTheBack'),
        MapUtils.get<number>(map, 'slotCount'),
    );
  }

  toMap(): SerializedData {
    return {
      'allowSchedulingFromTheFront': this.allowSchedulingFromTheFront,
      'allowSchedulingFromTheBack': this.allowSchedulingFromTheBack,
      'slotCount': this.slotCount,
    };
  }

  clone(): this {
    return new ClusteredSchedulingSettings(
        this.allowSchedulingFromTheFront,
        this.allowSchedulingFromTheBack,
        this.slotCount,
    ) as this;
  }

  isSame(other: ClusteredSchedulingSettings): boolean {
    if(this === other) {
      return true;
    }

    return other.allowSchedulingFromTheFront === this.allowSchedulingFromTheFront &&
           other.allowSchedulingFromTheBack === this.allowSchedulingFromTheBack &&
           other.slotCount === this.slotCount;
  }
}

export class ClusteredSchedulingSettingsBuilder extends DataModelBuilder<ClusteredSchedulingSettings> {
  build(context: SerializationContext, map: SerializedData): ClusteredSchedulingSettings {
    return ClusteredSchedulingSettings.fromMap(context, map);
  }
}
